import styled from 'styled-components'

import Theme from '@theme'

export const SubmissionCreatorNoteAccordionStyled = styled.div`
  > div:not(:last-child) {
    border-bottom: solid ${Theme.grey300Color} 1px;
  }
`
